import angular from 'angular';

import 'angular-ui-bootstrap';
import 'angularjs-slider';
import '../../../../../../../lib/assets/javascripts/devex/angular/services/routes.service';
/**
 * Component's template
 */
import template from './sidebar.html?raw';

let dependencies = [
  'ui.bootstrap.tpls',
  'ui.bootstrap.typeahead',
  'services.RoutesService',
  'rzSlider',
];

const options = {
  templateUrl: template,
  bindings: {
    searchJs: '=',
    flipper: '<',
  },
  controllerAs: 'vm',
  controller: [
    '$scope',
    'RoutesService',
    function ($scope, Routes) {
      var that = this;
      that.$scope = $scope;
      that.Routes = Routes;
      that.slider = {};
      that.companyName = null;
      that.autocomplete = {
        languages: null,
        citizenships: null,
        locations: null,
        locations_experience: null,
        job_titles: null,
        employers: null,
      };
      that.filters = {
        languages: '',
        citizenships: '',
        locations: '',
        locations_experience: '',
        job_titles: '',
        current: '',
        anytime: '',
        education_levels: ''
      };
      that.languagesLocationFilters = [
        {
          label: 'Languages',
          placeholder: 'Enter languages...',
          filter: 'languages',
          path: 'languages'
        },
        {
          label: 'Citizenships',
          placeholder: 'Enter citizenships...',
          filter: 'citizenships',
          path: 'places'
        },
        {
          label: 'Currently located in',
          placeholder: 'Enter country or region...',
          filter: 'locations',
          path: 'places'},
        {
          label: 'Location experience',
          placeholder: 'Enter country or region...',
          filter: 'locations_experience',
          path: 'places'
        }
      ];
      that.donorExperience = [
        {label: 'USAID', searchJsFilter: 'worked_as_a_usaid_implementer'},
        {label: 'EU', searchJsFilter: 'with_eu_experience'},
        {label: 'Australian DFAT', searchJsFilter: 'with_experience_in_dfat'},
        {label: 'FCDO', searchJsFilter: 'with_experience_in_fcdo'},
        {label: 'ADB', searchJsFilter: 'with_experience_in_adb'},
        {label: 'AfDB', searchJsFilter: 'with_experience_in_afdb'},
        {label: 'UN System', searchJsFilter: 'with_experience_in_un'},
        {label: 'World Bank', searchJsFilter: 'with_experience_in_wb'}
      ];
      that.dutyPost = [
        {label: 'Worked in conflict areas', searchJsFilter: 'with_experience_in_conflict_areas'},
        {label: 'International experience', searchJsFilter: 'with_international_experience'}
      ];
      that.jobSkills = [
        {label: 'Consulting experience', searchJsFilter: 'with_experience_in_consulting'},
        {
          label: 'Monitoring and Evaluation',
          searchJsFilter: 'with_experience_in_monitoring_and_eval'
        },
        {label: 'Managerial experience', searchJsFilter: 'with_managerial_experience'},
        {label: 'Business development', searchJsFilter: 'with_business_development_experience'},
        {label: 'Recruitment', searchJsFilter: 'with_experience_in_recruitment'}
      ];
      that.employersFilters = [
        {label: 'Current', filter: 'current', value: 'valueCurrent'},
        {label: 'Anytime', filter: 'anytime', value: 'value'}
      ];
      that.educationOptions = [
        {
          'id': 8000,
          'name': 'Certificate'
        },
        {
          'id': 8002,
          'name': 'Bachelor\'s Degree'
        },
        {
          'id': 8008,
          'name': 'Postgraduate Diploma'
        },
        {
          'id': 8003,
          'name': 'Master\'s Degree'
        },
        {
          'id': 8004,
          'name': 'MBA'
        },
        {
          'id': 8005,
          'name': 'Lawyer'
        },
        {
          'id': 8006,
          'name': 'Medical Doctor'
        },
        {
          'id': 8007,
          'name': 'Doctoral Degree'
        }
      ];

      /**
       * When $onInit is executed we have the props available so we can use searchJs to create the
       * options for the angularjs slider.
       * Gets the user company name if has one.
       *
       * @returns {undefined}
       */
      that.$onInit = () => {
        that.slider = {
          modelAsArray: [0, 50],
          options: {
            floor: 0,
            onEnd: () => {
              that.searchJs.filter.experience.value.min = that.slider.modelAsArray[0];
              that.searchJs.filter.experience.value.max = that.slider.modelAsArray[1];
              that.searchJs.notifyParamChange();
            },
            ceil: 50,
          },
        };

        fetch('/api/public/current_user')
          .then((res) => res.json())
          .then((res) => {
            if (res.company_name && /^devex$|^kfw/i.test(res.company_name)) {
              that.companyName = res.company_name;
            }
          });

        that.setIncomingExperienceFilter();
      };

      /**
       * If there is any incoming `experience` filter values in the URL
       * Adds this values to the angularjs-slider values.
       * We also call the setTimeout function with 500 milliseconds to execute the
       * `rzSliderForceRender` callback from the angularjs slider, this is because,
       * the rzslider  in the template doesn't have the `vm.slider` values until a few
       * milliseconds later.
       *
       * @returns {undefined}
       */
      that.setIncomingExperienceFilter = () => {
        let urlParams = new URLSearchParams(document.location.search);
        let min = urlParams.get('filter[experience][min]');
        let max = urlParams.get('filter[experience][max]');

        if (min && max) {
          that.slider.modelAsArray = [parseInt(min), parseInt(max)];
        }

        setTimeout(() => {
          that.$scope.$broadcast('rzSliderForceRender');
        }, 500);
      };

      /**
       * Request autocomplete options for the languages, location and companies filters, then
       * returns the options that are not already in the searchJS filters.
       *
       * @param {string} path get request path e.g. places languages
       * @param {string} filterValue the input value
       * @param {string} filterType searchJs and autocomplete filter
       * @param {string} [valueType] sometimes the searchJS filter has two values
       *
       * @returns {undefined}
       */
      that.getOptions = (path, filterValue, filterType, valueType = 'value') => {
        let urlParams = `?q=${filterValue}&types[]=country&types[]=region`;

        return fetch(`${that.Routes.api_autocomplete_path({ object: path })}${urlParams}`)
          .then((res) => res.json())
          .then((res) => {
            return res.data.filter((ele) => {
              return !that.searchJs.filter[filterType][valueType].includes(ele.text);
            });
          });
      };

      /**
       * When a filter is selected, adds this filter to the searchJs filters,
       * updates the search results and clear the fields.
       *
       * @param {string} filterValue filter to apply
       * @param {string} filterType input filter
       * @param {string} [valueType] if filter value is different
       * @param {string} [filterModel] if filter is different from the autocomplete filter
       *
       * @returns {undefined}
       */
      that.onFilterSelect =
        (filterValue, filterType, valueType = 'value', filterModel = filterType) => {
          that.searchJs.filter[filterType][valueType].push(filterValue);
          that.searchJs.notifyParamChange();
          that.filters[filterModel] = '';
        };

      /**
       * When user selects an Education level, adds the selected Value to SearchJS,
       * updates the search results and clear the field.
       *
       * @param {string} selectedValue filter to apply
       *
       * @returns {undefined}
       */
      that.onEducationLevelSelect = (selectedValue) => {
        that.searchJs.filter.education_levels.addValue(selectedValue);
        that.searchJs.notifyParamChange();
        that.filters.education_levels = '';
      };

      /**
       * Removes the selected filter from the searchJs filters and
       * updates the search results.
       *
       * @param {string} filterValue filter to remove
       * @param {string} filterType searchJs filter
       * @param {string} [valueType] if filter value is different
       *
       * @returns {undefined}
       */
      that.onFilterDeselect = (filterValue, filterType, valueType) => {
        if (valueType === 'valueCurrent') {
          that.searchJs.filter[filterType][valueType] = that.searchJs.filter[filterType][
            valueType
          ].filter((ele) => {
            return ele.name !== filterValue.name;
          });
          that.searchJs.notifyParamChange();
        } else {
          that.searchJs.filter[filterType].removeValue(filterValue);
          that.searchJs.notifyParamChange();
        }
      };

      /**
       * Filter the education level options, taking into what the SearchJS `education_levels` filter
       * value is.
       *
       * @returns {Array} - Array of education level options
       */
      that.getEducationLevelAutocompleteEntries= () => {
        const selectedEntries = that.searchJs.filter.education_levels.getValue();

        return that.educationOptions.filter((option) =>
          selectedEntries.every((filterName) => filterName !== option.name)
        );
      };

      /**
       * Clears all the filters in searchJs and updates the results.
       *
       * @returns {undefined}
       */
      that.clearAllFilters = () => {
        let browserUrl = devex.urls.BrowserUrl.getInstance();
        that.searchJs.reset();
        that.searchJs.filter.employers.value = [];
        that.searchJs.filter.employers.valueCurrent = [];
        that.slider.modelAsArray = [0, 50];
        browserUrl.updateUrl();
      };
    },
  ],
};

angular
  .module('components.sidebar', dependencies)
  .run(['$templateCache', function ($templateCache) {
    $templateCache.put(template, template);
  }])
  .component('sidebar', options);
